import { N0 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';
import React from 'react';
import { HeaderDevopsOptionsType } from '../../../../../model';
import { SignupLayoutAnalytics } from '../../../../../service';
import {
  Layout,
  SideInformationComponent
} from '../../side-information-component';
import {
  FREE_EDITION_LABEL_KEY,
  getSideInfoHeader
} from '../../utility/sign-up-layout-container';
import { HeaderBackgroundDevops, HeaderBackgroundDevopsMobile } from '../asset';
import { ReducedRow } from '../styled';

/**
 * Devops Header containing background,
 * listed products & Devops Features list
 */

export function HeaderDevops({
  labels,
  productKeys,
  analyticsTrack,
  formExistingSiteShown,
  userInfo
}: HeaderDevopsOptionsType) {
  const layout: Layout = 'devops';
  const edition = FREE_EDITION_LABEL_KEY.toLowerCase();
  const analytics = new SignupLayoutAnalytics({
    isLoggedIn: false,
    analyticsTrack
  });
  const switchUserInfo = ({
    switchAccountUrl: analytics.switchAccountUrl,
    switchUserOrigin: analytics.originAnalyticsAttributes.switchUser
  } = analytics);
  return (
    <HeaderWrapper>
      <InfinityLogo />
      <ReducedRow>
        <RowPadding>
          <SideInformationComponent
            layout={layout}
            logoColor={N0}
            edition={edition}
            productKeys={productKeys}
            featuresList=""
            trialDurationNewSite=""
            trialDurationExistingSite=""
            imgSource=""
            isMobile={false}
            analyticsTrack={analyticsTrack}
            sideInfoHeader={getSideInfoHeader({ labels, productKeys })}
            isExistingSiteFormShown={formExistingSiteShown}
            userInfo={userInfo}
            switchUserInfo={switchUserInfo}
          />
        </RowPadding>
      </ReducedRow>
    </HeaderWrapper>
  );
}

const HeaderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 320px;

  @media only screen and (max-width: 800px) {
    height: 164px;
  }
`;

const InfinityLogo = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;

  background-repeat: no-repeat;
  background-size: 1920px 320px;
  background-position: center;
  background-image: url(data:image/svg+xml;base64,${HeaderBackgroundDevops});

  @media only screen and (max-width: 800px) {
    background-size: 4000px 700px;
    background-position: -810px -342px;
    background-image: url(data:image/svg+xml;base64,${HeaderBackgroundDevopsMobile});
  }
`;

const RowPadding = styled.div`
  padding: 0px 48px;
  @media only screen and (max-width: 800px) {
    padding: 0px 22px;
  }
  div,
  span {
    max-width: none;
  }

  .product-heading {
    margin: 30px auto -20px auto;
  }
`;
